var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",attrs:{"src":_vm.currentAudioSrc,"autoplay":true},on:{"ended":_vm.playNextAudio}})
}
var staticRenderFns = []

export { render, staticRenderFns }